import config from "../../config"
import RequestService from "../RequestService"

const fetchTicketNotes = (ticketId, successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/ticket_notes?ticket_id=${ticketId}`, successCallback, failureCallback)
}

export default fetchTicketNotes;